import React from "react";
import { css } from "react-emotion";

import { TextComponent } from "components";

const link = css`
  color: white;
  cursor: pointer;

  &:hover {
    text-shadow: 0 0 0.04rem white;
  }
`;

const NavLink = (props) => {
  // console.dir(props);
  const { title } = props;
  return (
    <div className={link} onClick={props.onClick}>
      <TextComponent {...title} />
    </div>
  );
};

export default NavLink;
